// @flow
const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
const SET_LOGGING_OUT = 'SET_LOGGING_OUT';
const SET_TRANSACTION_LOCKING = 'SET_TRANSACTION_LOCKING';
const SET_PERMISSIONS = 'SET_PERMISSIONS';
const SET_AUDIT_LOCK_TRANSACTION = 'SET_AUDIT_LOCK_TRANSACTION';

export function updateUserToken(accessToken) {
  return {
    type: SET_ACCESS_TOKEN,
    accessToken,
  };
}

export function updateUserPermissions(permissions) {
  return {
    type: SET_PERMISSIONS,
    permissions,
  };
}

export function authUser(data) {
  return {
    type: AUTHENTICATE_USER,
    data,
  };
}

export function updateProfileData(data) {
  return {
    type: SET_PROFILE_DATA,
    data,
  };
}

export function setLoggingOut() {
  return {
    type: SET_LOGGING_OUT,
  };
}

export function setTransactionLocking(data) {
  return {
    type: SET_TRANSACTION_LOCKING,
    data,
  };
}

export function setAuditLockTransaction(data) {
  return {
    type: SET_AUDIT_LOCK_TRANSACTION,
    data,
  };
}

const initialState = {
  isAuthed: false,
  isLoggingOut: false,
  profileData: {},
  accessToken: null,
  permissions: [],
  slBuilder: [],
  transaction_locking: [],
  audit_lock_transaction: [],
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        isLoggingOut: false,
        accessToken: action.accessToken,
      };
    case AUTHENTICATE_USER:
      return {
        ...state,
        profileData: action.data.user,
        isAuthed: true,
        accessToken: action.data.accessToken,
        permissions: action.data.permissions,
        slBuilder: action.data.slBuilder,
        transaction_locking: action.data.transaction_locking,
      };
    case SET_PROFILE_DATA:
      return {
        ...state,
        profileData: {
          ...state.profileData,
          ...action.data.user,
        },
      };
    case SET_TRANSACTION_LOCKING:
      return { ...state, transaction_locking: action.data };
    case SET_PERMISSIONS:
      return {
        ...state,
        permissions: action.permissions,
      };
    case SET_AUDIT_LOCK_TRANSACTION:
      return { ...state, audit_lock_transaction: action.data };
    case SET_LOGGING_OUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
